import PropTypes from 'prop-types';

import logo from 'public/images/logo.png';

import { useCompanyBranding } from 'resources/company/hooks';

import styles from './styles.module.css';

const BoxLayout = ({ children }) => {
  const { companyLogoUrl } = useCompanyBranding();

  return (
    <div className={styles.wrapper}>
      <header
        className={styles.header}
      >
        <img src={companyLogoUrl || logo} width="130" alt="logo" />
      </header>

      <main className={styles.content}>
        {children}
      </main>
    </div>
  );
};

BoxLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BoxLayout;
